import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="min-h-dvh flex flex-col items-center justify-center text-center px-6">
      <p className="font-mono text-xs text-wca-gray-mid uppercase tracking-widest">Error 404</p>
      <h1 className="font-display text-5xl mt-4">Page not found</h1>
      <Link to="/" className="mt-8 text-wca-red hover:underline font-medium">
        ← Back to The Cracked Mug
      </Link>
    </section>
  );
}
